namespace Portico {

	import pm = Portico.Models;
	import pme = Portico.Models.Enterprise;
	import pmi = Portico.Models.Interfaces;
	import pms = Portico.Models.Setup;
	import ps = Portico.Services;
    
    angular.module('app').config([
		'$locationProvider',
		'$logProvider',
        '$stateProvider',
		'$urlRouterProvider', (
			$locationProvider: angular.ILocationProvider,
			$logProvider: angular.ILogProvider,
            $stateProvider: angular.ui.IStateProvider,
            $urlRouterProvider: angular.ui.IUrlRouterProvider
        ) => {
			$locationProvider.html5Mode(false).hashPrefix('');
            $urlRouterProvider.otherwise('/app/layout/home');

            $stateProvider
				// app
				.state('app', {
					abstract: true,
					controller: 'appController',
					controllerAs: '$app',
                    resolve: {
						initApp: ['$q', '$stateParams', 'actionService', 'dataService', 'storageService', 'porticoService', ($q: angular.IQService, $stateParams: angular.ui.IStateParamsService, actionService: ps.IActionService, dataService: ps.IDataService, storageService: ps.IStorageService, porticoService: ps.IPorticoService) => {
							// set state variables
							dataService.state.app = $stateParams['app'];

							// get data from local storage
							dataService.local = storageService.getItem<ps.KvpMap>(pm.StorageType.Session, 'data');

							if (!dataService.local) {
								dataService.local = {};
								storageService.saveItem<ps.KvpMap>(pm.StorageType.Session, 'data', dataService.local);
							}

							// get data from session storage
							dataService.session = storageService.getItem<ps.KvpMap>(pm.StorageType.Session, 'data');

							if (!dataService.session) {
								dataService.session = {};
								storageService.saveItem<ps.KvpMap>(pm.StorageType.Session, 'data', dataService.session);
							}

							// set mode from query params
							if ($stateParams['mode']) {
								dataService.session.mode = $stateParams['mode'];
							}

							// get portal and setup data
							const promise0 = actionService
								.scope()
								.initDataTables()
								.initDataTypes()
								.initPortal()
								.promise();

							return promise0.then((result0) => {
								const useSession = dataService.getDataValue('Reference', 'Id', 'use-session', '').toLowerCase() === 'true';
								const sessionPromise = useSession && !porticoService.authenticationService.hasSession() ?
									porticoService.authenticationService.createSession() :
									null;

								return $q.when(sessionPromise).then((sessionResult) => {
									// evaluate actions from database
									let actions1 = null;
									if (!actions1) actions1 = dataService.getDataValue('Resolve', 'Eval', `app`);
									const promise1 = actions1 ? eval(actions1) : true;

									return $q.when(promise1).then((result1) => {
										let actions2 = null;
										if (!actions2) actions2 = dataService.getDataValue('Resolve', 'Eval', `app-${dataService.state.app}`);
										const promise2 = actions2 ? eval(actions2) : true;

										return $q.when(promise2).then((result2) => {
											return angular.extend({}, result0, result1, result2);
										});
									});
								});
							});
						}]
					},
					templateProvider: ['$stateParams', ($stateParams: angular.ui.IStateParamsService) => {
						const app = $stateParams['app'];
						return `<tc-html schema="Layout" column="Html" key="app"/>`;
					}],
					url: '/:app?mode'
				})
				// app > layout
				.state('app.layout', {
					abstract: true,
					controller: 'layoutController',
					controllerAs: '$layout',
					resolve: {
						initLayout: ['initApp', '$q', '$stateParams', 'actionService', 'dataService', 'porticoService', (initApp: boolean, $q: angular.IQService, $stateParams: angular.ui.IStateParamsService, actionService: ps.IActionService, dataService: ps.IDataService, porticoService: ps.IPorticoService) => {
							dataService.state.layout = $stateParams['layout'];

							let actions1 = null;
							if (!actions1) actions1 = dataService.getDataValue('Resolve', 'Eval', `app-${dataService.state.app}.layout`);
							if (!actions1) actions1 = dataService.getDataValue('Resolve', 'Eval', `layout`);
							const promise1 = actions1 ? eval(actions1) : true;

							return $q.when(promise1).then((result1) => {
								let actions2 = null;
								if (!actions2) actions2 = dataService.getDataValue('Resolve', 'Eval', `app-${dataService.state.app}.layout-${dataService.state.layout}`);
								if (!actions2) actions2 = dataService.getDataValue('Resolve', 'Eval', `layout-${dataService.state.layout}`);
								const promise2 = actions2 ? eval(actions2) : true;

								return $q.when(promise2).then((result2) => {
									return angular.extend({}, result1, result2);
								});
							});
						}]
					},
					templateProvider: ['$stateParams', ($stateParams: angular.ui.IStateParamsService) => {
						const layout = $stateParams['layout'];
						return `<tc-html schema="Layout" column="Html" key="${layout}" />`;
					}],
					url: '/:layout'
				})
				// app > layout > page
				.state('app.layout.page', {
					controller: 'pageController',
					controllerAs: '$page',
                    resolve: {
						initPage: ['initLayout', '$q', '$stateParams', 'actionService', 'dataService', 'porticoService', (initLayout: boolean, $q: angular.IQService, $stateParams: angular.ui.IStateParamsService, actionService: ps.IActionService, dataService: ps.IDataService, porticoService: ps.IPorticoService) => {
							dataService.state.page = $stateParams['page'];
							dataService.state.ppid = $stateParams['ppid'];
							dataService.state.psid = $stateParams['psid'];
							dataService.state.r2p = $stateParams['r2p'];
                            
							let actions1 = null;
							if (!actions1) actions1 = dataService.getDataValue('Resolve', 'Eval', `app-${dataService.state.app}.layout-${dataService.state.layout}.page`);
							if (!actions1) actions1 = dataService.getDataValue('Resolve', 'Eval', `layout-${dataService.state.layout}.page`);
							if (!actions1) actions1 = dataService.getDataValue('Resolve', 'Eval', `page`);
							const promise1 = actions1 ? eval(actions1) : true;

							return $q.when(promise1).then((result1) => {
								let actions2 = null;
								if (!actions2) actions2 = dataService.getDataValue('Resolve', 'Eval', `app-${dataService.state.app}.layout-${dataService.state.layout}.page-${dataService.state.page}`);
								if (!actions2) actions2 = dataService.getDataValue('Resolve', 'Eval', `layout-${dataService.state.layout}.page-${dataService.state.page}`);
								if (!actions2) actions2 = dataService.getDataValue('Resolve', 'Eval', `page-${dataService.state.page}`);
								const promise2 = actions2 ? eval(actions2) : true;

								return $q.when(promise2).then((result2) => {
									return angular.extend({}, result1, result2);
								});
							});
						}]
					},
					templateProvider: ['$stateParams', ($stateParams: angular.ui.IStateParamsService) => {
						const page = $stateParams['page'];
						return `<tc-html schema="Page" column="Html" key="${page}"/>`;
					}],
					url: '/:page?ppid&psid&r2p'
				})
                // app > layout > page > intake
				.state('app.layout.page.intake', {
                    abstract: true,
                    controller: 'intakeController',
                    controllerAs: '$intake',
                    resolve: {
						initIntake: ['initPage', '$q', '$stateParams', 'actionService', 'dataService', 'porticoService', (initPage: boolean, $q: angular.IQService, $stateParams: angular.ui.IStateParamsService, actionService: ps.IActionService, dataService: ps.IDataService, porticoService: ps.IPorticoService) => {
							dataService.state.intake = $stateParams['intake'];

							let actions1 = null;
							if (!actions1) actions1 = dataService.getDataValue('Resolve', 'Eval', `app-${dataService.state.app}.layout-${dataService.state.layout}.page-${dataService.state.page}.intake`);
							if (!actions1) actions1 = dataService.getDataValue('Resolve', 'Eval', `layout-${dataService.state.layout}.page-${dataService.state.page}.intake`);
							if (!actions1) actions1 = dataService.getDataValue('Resolve', 'Eval', `page-${dataService.state.page}.intake`);
							if (!actions1) actions1 = dataService.getDataValue('Resolve', 'Eval', `intake`);
							const promise1 = actions1 ? eval(actions1) : {};

							return $q.when(promise1).then((result1) => {
								let actions2 = null;
								if (!actions2) actions2 = dataService.getDataValue('Resolve', 'Eval', `app-${dataService.state.app}.layout-${dataService.state.layout}.page-${dataService.state.page}.intake-${dataService.state.intake}`);
								if (!actions2) actions2 = dataService.getDataValue('Resolve', 'Eval', `layout-${dataService.state.layout}.page-${dataService.state.page}.intake-${dataService.state.intake}`);
								if (!actions2) actions2 = dataService.getDataValue('Resolve', 'Eval', `page-${dataService.state.page}.intake-${dataService.state.intake}`);
								if (!actions2) actions2 = dataService.getDataValue('Resolve', 'Eval', `intake-${dataService.state.intake}`);
								const promise2 = actions2 ? eval(actions2) : {};

								return $q.when(promise2).then((result2) => {
									return angular.extend({}, result1, result2);
								});
							});
						}]
                    },
                    templateProvider: ['$stateParams', ($stateParams: angular.ui.IStateParamsService) => {
                        const intake = $stateParams['intake'];
                        return `<tc-html schema="Intake" column="Html" key="${intake}"/>`;
                    }],
					url: '/:intake'
                })
                // app > layout > page > intake > section
				.state('app.layout.page.intake.section', {
                    controller: 'sectionController',
                    controllerAs: '$section',
					resolve: {
						initSection: ['initIntake', '$q', '$stateParams', 'actionService', 'dataService', 'porticoService', (initIntake: boolean, $q: angular.IQService, $stateParams: angular.ui.IStateParamsService, actionService: ps.IActionService, dataService: ps.IDataService, porticoService: ps.IPorticoService) => {
							dataService.state.section = $stateParams['section'];
							dataService.state.spid = $stateParams['spid'];
							dataService.state.ssid = $stateParams['ssid'];
							dataService.state.r2s = $stateParams['r2s'];

							let actions1 = null;
							if (!actions1) actions1 = dataService.getDataValue('Resolve', 'Eval', `app-${dataService.state.app}.layout-${dataService.state.layout}.page-${dataService.state.page}.intake-${dataService.state.intake}.section`);
							if (!actions1) actions1 = dataService.getDataValue('Resolve', 'Eval', `layout-${dataService.state.layout}.page-${dataService.state.page}.intake-${dataService.state.intake}.section`);
							if (!actions1) actions1 = dataService.getDataValue('Resolve', 'Eval', `page-${dataService.state.page}.intake-${dataService.state.intake}.section`);
							if (!actions1) actions1 = dataService.getDataValue('Resolve', 'Eval', `intake-${dataService.state.intake}.section`);
							if (!actions1) actions1 = dataService.getDataValue('Resolve', 'Eval', `section`);
							const promise1 = actions1 ? eval(actions1) : true;

							return $q.when(promise1).then((result1) => {
								let actions2 = null;
								if (!actions2) actions2 = dataService.getDataValue('Resolve', 'Eval', `app-${dataService.state.app}.layout-${dataService.state.layout}.page-${dataService.state.page}.intake-${dataService.state.intake}.section-${dataService.state.section}`);
								if (!actions2) actions2 = dataService.getDataValue('Resolve', 'Eval', `layout-${dataService.state.layout}.page-${dataService.state.page}.intake-${dataService.state.intake}.section-${dataService.state.section}`);
								if (!actions2) actions2 = dataService.getDataValue('Resolve', 'Eval', `page-${dataService.state.page}.intake-${dataService.state.intake}.section-${dataService.state.section}`);
								if (!actions2) actions2 = dataService.getDataValue('Resolve', 'Eval', `intake-${dataService.state.intake}.section-${dataService.state.section}`);
								if (!actions2) actions2 = dataService.getDataValue('Resolve', 'Eval', `section-${dataService.state.section}`);
								const promise2 = actions2 ? eval(actions2) : true;

								return $q.when(promise2).then((result2) => {
									return angular.extend({}, result1, result2);
								});
							});
						}]
					},
					templateProvider: ['$stateParams', ($stateParams: angular.ui.IStateParamsService) => {
						const section = $stateParams['section'];
                        return `<tc-html schema="Section" column="Html" key="${section}"/>`;
                    }],
					url: '/:section?spid&ssid&r2s',
                });
        }
    ]);
}